import React, { useState, useEffect } from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { useSearchParams } from 'react-router-dom';
import ManagementOpenNetworkLog from './open-network-logs/containers/open-network-log';
import InsightsOnSearchLogs from './insights/containers/insights';
import RejectionLogs from './rejections/containers/rejections';

export const ManagementDBNCockpits = () => {
    const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const tabItems = [
        {
            id: 0,
            title: `OpenNetwork Logs Search`,
            component: <ManagementOpenNetworkLog />,
            isVisible: true,
        },
        {
            id: 1,
            title: 'Insights Logs',
            component: <InsightsOnSearchLogs />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Rejection Logs',
            component: <RejectionLogs />,
            isVisible: true,
        },
    ];

    useEffect(() => {
        const tabTitleFromURL = searchParams.get('tab');
        if (tabTitleFromURL) {
            const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
            if (tabIndex !== -1) {
                setSelectedTabIndex(tabIndex);
            }
        } else {
            setSelectedTabIndex(0);
        }
    }, [searchParams]);

    const handleTabChange = (index: number) => {
        setSelectedTabIndex(index);
        setSearchParams({ tab: tabItems[index].title });
    };

    if (selectedTabIndex === null) {
        return null;
    }

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer
                tabItems={tabItems}
                selectedIndex={selectedTabIndex}
                onChange={handleTabChange}
            />
        </div>
    );
};

export default ManagementDBNCockpits;
